import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { FaArrowLeft, FaRegUserCircle } from "react-icons/fa";
import { useTranslation } from 'react-i18next'

const TeacherUnreadNotification = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div>
      <div>
        <div className="flex items-center xl:p-5 sm:p-0 justify-center">
          <div className="w-full border rounded-3xl shadow-xl p-5">
            <div>
              <div>

                <FaArrowLeft className='mb-5 cursor-pointer ' onClick={() => navigate(-1)} />
              </div>
              <p className='text-2xl font-bold'>{t("adminDash.notifications")}</p>
              <p className='text-[#22B7AA] font-light text-sm'>{t("adminDash.teacherNoti.teacherNameNotification")}</p>
            </div>
            <div className=" flex border-b-2 justify-between items-center mt-8">
              <div className='flex flex-wrap md:justify-start md:space-x-12  space-x-5  text-base font-medium '>
                <NavLink to=".././teacher-notification" className={({ isActive }) => (isActive ? "text-blue-500 border-b-2 border-blue-500" : undefined)}>{t("adminDash.studentNoti.all")}</NavLink>

                <NavLink to=".././teacher-new-noti" className={({ isActive }) => (isActive ? "text-blue-500 border-b-2 border-blue-500" : undefined)}>{t("adminDash.studentNoti.new")}</NavLink>

                <NavLink to=".././teacher-unread-noti" className={({ isActive }) => (isActive ? "text-blue-500 border-b-2 border-blue-500" : undefined)}>{t("adminDash.studentNoti.unread")}</NavLink>
              </div>
              <div>
                <p className='text-[12px] bg-[#FAFAF8] text-[#7E7E7E] font-semibold border-[#7E7E7E] p-1 rounded-lg cursor-pointer mb-2'>{t("adminDash.studentNoti.markAllRead")}</p>
              </div>
            </div>

            <div className='grid grid-cols-4 gap-4 my-4 bg-[#A3E7E11C] p-4'>

              <div className='flex gap-2'>
                <div>
                  <FaRegUserCircle className='h-8 w-8' />
                </div>
                <div>
                  <p className='text-[#2D3748] text-[14px] font-semibold'>Muslim </p>
                  <span className='text-[12px] text-[#2D3748] '>{t("adminDash.studentNoti.onlineClass")}</span>
                </div>
              </div>
              <div className='flex gap-5 text-[12px] text-[#2D3748] items-center'>
                <p>{t("adminDash.studentNoti.thursday")}</p>
                <p>4:30 PM</p>

              </div>
              <div className='text-end'>
                <button className='border rounded-sm text-[12px] text-[#828282] px-5 py-1 font-semibold  bg-[#4FD1C50D]'>{t("adminDash.studentNoti.new")}</button>
              </div>

              <div className='flex gap-4 justify-end'>

                <div>
                  <button className='border rounded-sm text-[12px] text-[#828282] px-5 py-1 font-semibold  bg-[#4FD1C50D]'>{t("adminDash.studentNoti.accept")}</button>
                </div>

                <div>
                  <button className='border rounded-sm text-[12px] text-[#828282] px-5 py-1 font-semibold  bg-[#4FD1C50D]'>{t("adminDash.common.delete")}</button>
                </div>
              </div>

            </div>


          </div>
        </div>
      </div>
    </div>
  )
}

export default TeacherUnreadNotification
